// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__14QYc","empty":"ModalGraph_empty__23k5W"};